type ThumbsDownProps = {
  className?: string;
  color?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const ThumbsDown = ({
  className,
  color,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: ThumbsDownProps) => {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-tooltip-id="thumbs-down-tooltip"
        viewBox="0 0 12 12"
        fill={color || "currentColor"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule={`${color ? "nonzero" : "evenodd"}`}
          clipRule="evenodd"
          d="M3.97404 11.2252C3.92036 11.075 3.91301 10.9125 3.95291 10.7581L4.58182 8.32264H1.09091C0.801583 8.32264 0.524106 8.20936 0.31952 8.0077C0.114935 7.80605 5.83968e-07 7.53255 5.83968e-07 7.24737V6.11619C-0.000146918 5.97567 0.0276495 5.83649 0.0818182 5.70651L1.77 1.66618C1.81118 1.56767 1.88113 1.48345 1.97096 1.4242C2.06079 1.36495 2.16646 1.33334 2.27455 1.33338H8.18182C8.32648 1.33338 8.46522 1.39002 8.56751 1.49085C8.66981 1.59168 8.72727 1.72843 8.72727 1.87102V8.10006C8.72724 8.24264 8.66975 8.37937 8.56745 8.48017L5.07655 11.921C5.03015 11.9669 4.96851 11.9947 4.90297 11.9994C4.83743 12.004 4.77239 11.9852 4.71982 11.9463L4.25455 11.6022C4.12533 11.5066 4.02772 11.3754 3.97404 11.2252ZM1.13333 7.18931V6.12958L2.6638 2.46671H7.59394V7.8484L5.28782 10.1215L6.04498 7.18931H1.13333Z"
        />
        <path d="M9.81824 7.785H11.4546C11.5993 7.785 11.738 7.72836 11.8403 7.62753C11.9426 7.52671 12.0001 7.38996 12.0001 7.24737V1.87101C12.0001 1.72842 11.9426 1.59167 11.8403 1.49084C11.738 1.39002 11.5993 1.33337 11.4546 1.33337H9.81824V7.785Z" />
      </svg>
    </>
  );
};

export default ThumbsDown;
